var map = {
	"./blue.svg": "d92c",
	"./dark-blue.svg": "28e8",
	"./dark-green.svg": "280e",
	"./dark-purple.svg": "eb23",
	"./default.svg": "a96c",
	"./estimated-property.svg": "db29",
	"./light-blue.svg": "55ec",
	"./light-green.svg": "9343",
	"./orange.svg": "f45c",
	"./pink.svg": "49bb",
	"./purple.svg": "023d",
	"./red.svg": "1430",
	"./yellow.svg": "452a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91ff";